<template>
  <div v-show="isDownloadLoading" id="downloadLoadingBox">
    <div class="loadingMain">
      <i class="el-icon-loading"></i>
      <p>{{$t('projectDetailsV2.downloading')}}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DownloadLoadingBox',
  props: {
    isDownloadLoading: {
      type: Boolean,
      require: true,
    },
    asyncDownloadFun: {
      type: Function,
      require: true,
    },
    asyncResultUrl: {
      type: String,
      default () {
        return '/api/v1/file/getDownloadAsyncResult';
      }
    }
  },
  methods: {
    async asynDownload() {
      const response = await this.asyncDownloadFun();
      if (response.resultCode === "1") {
        const result = response.result;
        if (response.result.percent == 100) {
          this.downloadServerFile(result.fileName, result.downloadUrl);
          this.$emit('handleClose');
        } else {
          this.getDownloadAsyncResult(result.taskKey)
        }
      } else {
        this.$emit('handleClose');
      }
    },
    // 下载轮询
    async getDownloadAsyncResult (taskKey) {
      var setItem = setInterval(async () => {
        const response = await this.catReq1Service(this.asyncResultUrl, { taskKey }, 'get')
        if (response.resultCode === "1") {
          const result = response.result;
          if (result.percent == 100) {
            clearInterval(setItem);
            setItem = null;
            this.$emit('handleClose');
            this.downloadServerFile(result.fileName, result.downloadUrl)
          }
        } else {
          clearInterval(setItem);
          setItem = null;
          this.$emit('handleClose');
        }
      }, 2000);
    },
    // 下载指定的服务文件
    downloadServerFile (fileName, filePath) {
      let link = document.createElement("a");
      link.style.display = "none";
      link.href = this.baseURL + `/api/v1/file/downloadServerFile?fileName=${fileName}&filePath=${filePath}`;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
    },
  },
  watch: {
    isDownloadLoading: {
      handler (newVal) {
        if (newVal) {
          this.asynDownload();
        }
      },
      deep: true,
    }
  }
}
</script>

<style lang="less" scoped>
#downloadLoadingBox {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 1);
  opacity: 0.5;
  z-index: 1000;

  .loadingMain {
    text-align: center;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 20px;
    color: #fff;
    i {
      font-size: 30px;
    }
  }
}
</style>